import { render } from "./Tolbar.vue?vue&type=template&id=2a903752&scoped=true"
import script from "./Tolbar.vue?vue&type=script&lang=js"
export * from "./Tolbar.vue?vue&type=script&lang=js"

import "./Tolbar.vue?vue&type=style&index=0&id=2a903752&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a903752"]])

export default __exports__